import { Injectable } from '@angular/core';

@Injectable()
export class JsonService {

  constructor() { }
  /**
   * Json parser that returns empty array if there is a parsing error,
   * error and invalid string are printed to console.
   *
   * @param {string} JsonString JSON string to be parsed
   * @returns array of objects or empty array
   * @memberof JsonService
   */
  getArrayFromJSON(JsonString: string) {
    let result = [];
    try {
      result = JSON.parse(JsonString);
    } catch (error) {
      console.warn('Error parsing JSON: ', JsonString, error);
    }
    return result;
  }

}
